<div class="monthly-overview-wrapper">
<div class="monthly-overview-card cashflow-card with-border">
  <div class="amount-container">
    <span class="title">{{
      'auth.dashboard.monthlyOverview.accountBalances' | translate
    }}</span>
    <ng-container *ngIf="favoriteAccountsBalances?.length; else noFavAccounts">
      <div class="favorite-accounts">
        <div class="favorite-account" *ngFor="let acc of favoriteAccountsBalances">
          <span class="title">{{ acc.bankAccount }}</span>
          <span class="amount">{{ symbolFor(acc.currency) }}{{ acc.balance | number : '.0-0' }}</span>
        </div>
      </div>
    </ng-container>
    <ng-template #noFavAccounts>
      <span class="amount">
        {{ companyBaseCurrency }}{{
          monthlyOverviewData?.monthlyBalance[0]
            ? (monthlyOverviewData?.monthlyBalance[0].balance | number : '.0-0')
            : 0
        }}
      </span>
    </ng-template>
  </div>
  <div class="date-container top-right">
    <span><span class="month">{{ today | date : 'MMM' | uppercase }}</span> {{ today | date : 'dd, YYYY' }}</span>
    <button class="refresh-button" (click)="refreshData()" type="button" [disabled]="isRefreshing" [attr.aria-label]="'Refresh data' | translate">
      <svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect x="2" y="2" width="12" height="12" rx="2" stroke="#747efa" stroke-width="1" fill="none"/>
        <path d="M10.8 5.2C10.2 4.4 9.1 4 8 4C5.8 4 4 5.8 4 8C4 10.2 5.8 12 8 12C10.2 12 12 10.2 12 8" stroke="#747efa" stroke-width="1.5" stroke-linecap="round" fill="none"/>
        <path d="M10.08 3.32L11.4 6.0L8.9 5.7" stroke="#747efa" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" fill="none"/>
      </svg>
    </button>
  </div>
</div>
<div class="expected-container">
  <div class="monthly-overview-card">
    <div class="amount-container">
      <span class="title">{{
        'auth.dashboard.monthlyOverview.receivedIncome' | translate
      }}</span>
      <span class="amount">
        {{ companyBaseCurrency }}{{ receivedIncome | number : '.0-0' }}
      </span>
    </div>
    <div class="date-container">
      <span>{{ today | date : 'MMM' | uppercase }}</span>
    </div>
  </div>
  <div class="monthly-overview-card">
    <div class="amount-container">
      <span class="title">{{
        'auth.dashboard.monthlyOverview.expectedIncome' | translate
      }}</span>
      <span class="amount">
        {{ companyBaseCurrency }}{{ expectedIncome | number : '.0-0' }}
      </span>
    </div>
    <div class="date-container">
      <span>{{ today | date : 'MMM' | uppercase }}</span>
    </div>
  </div>
  <div class="monthly-overview-card">
    <div class="amount-container">
      <span class="title">{{
        'auth.dashboard.monthlyOverview.paidExpense' | translate
      }}</span>
      <span class="amount expense">
        {{ companyBaseCurrency }}{{ paidExpense | number : '.0-0' }}
      </span>
    </div>
    <div class="date-container">
      <span>{{ today | date : 'MMM' | uppercase }}</span>
    </div>
  </div>
  <div class="monthly-overview-card">
    <div class="amount-container">
      <span class="title">{{
        'auth.dashboard.monthlyOverview.expectedExpense' | translate
      }}</span>
      <span class="amount expense">
        {{ companyBaseCurrency }}{{ expectedExpense | number : '.0-0' }}
      </span>
    </div>
    <div class="date-container">
      <span>{{ today | date : 'MMM' | uppercase }}</span>
    </div>
  </div>
</div>
<div class="monthly-overview-card pnl-card">
  <div class="amount-container">
    <span class="title">{{
      'auth.dashboard.monthlyOverview.monthlyPnl' | translate
    }}</span>
    <span class="amount">
      {{ companyBaseCurrency }}{{ profitability | number : '.0-0'}}
    </span>
  </div>
  <div class="date-container">
    <span>{{ today | date : 'MMM' | uppercase }}</span>
  </div>
</div>
<div class="refresh-overlay" [class.visible]="isRefreshing">
  <div class="refresh-spinner"></div>
</div>
</div>
